import {connect} from 'react-redux';

import {DASHBOARD_SCREEN, TEAMS_SCREEN} from '/enum/screen.enum';
import {competencyById} from '/redux/selector/coach.selector';
import {userId} from '/redux/selector/currentUser.selector';
import {
  executiveDirectorTeamsCount,
  fibcTeamsCount,
  fiblTeamsCount,
  seniorCoachTeamsCount,
} from '/redux/selector/metric.home.selector';
import {
  teamsExecutiveDirectorById,
  teamsFibcById,
  teamsFiblById,
  teamsSeniorCoachById,
} from '/redux/selector/metric.teams.selector';
import {createStructuredScreenSelector, withProps} from '/util/selector.util';

import TeamsOverviewSection from './TeamsOverviewSection';

const withCoachUserId = withProps({coachId: userId});

const SELECTOR_MAP = {
  teamsExecutiveDirector: {
    [DASHBOARD_SCREEN]: executiveDirectorTeamsCount,
    [TEAMS_SCREEN]: teamsExecutiveDirectorById,
  },
  teamsFibc: {
    [DASHBOARD_SCREEN]: fibcTeamsCount,
    [TEAMS_SCREEN]: teamsFibcById,
  },
  teamsFibl: {
    [DASHBOARD_SCREEN]: fiblTeamsCount,
    [TEAMS_SCREEN]: teamsFiblById,
  },
  teamsSenior: {
    [DASHBOARD_SCREEN]: seniorCoachTeamsCount,
    [TEAMS_SCREEN]: teamsSeniorCoachById,
  },
};

export default connect(
  createStructuredScreenSelector({
    selectorMap: SELECTOR_MAP,
    defaultScreenName: TEAMS_SCREEN,
    otherSelectors: {currentUserCompetency: competencyById},
    effect: withCoachUserId,
  }),
)(TeamsOverviewSection);
